export default __webpack_public_path__ + "347456fe80d516f257886a278c17f67a.png";